module.exports = __webpack_public_path__ + "img/upgrade.61df3930.svg";